module.exports = __webpack_public_path__ + "static/media/urlParam.c8e28570.svg";